// Shared declarable-car catalog for custom series (#279/#282). The three NASCAR
// cars are fully supported end-to-end (pit profiles + fuel capacity + auto-
// attributed runs); the rest are declarable labels (badges via #281, fuel via the
// per-car map in #280). Keyed by the canonical car-id slug used everywhere.
export interface CarCatalogEntry {
  id: string;
  label: string;
  full?: boolean;
}

export const CAR_CATALOG: CarCatalogEntry[] = [
  { id: "nascar-cup-next-gen", label: "Cup · Next Gen", full: true },
  { id: "nascar-oreilly", label: "Xfinity", full: true },
  { id: "nascar-trucks", label: "Trucks", full: true },
  { id: "late-model", label: "Late Model" },
  { id: "super-late-model", label: "Super Late Model" },
  { id: "modified", label: "Modified" },
  { id: "gt3", label: "GT3" },
  { id: "gt4", label: "GT4" },
];

export function carCatalogLabel(id: string): string {
  return CAR_CATALOG.find((c) => c.id === id)?.label || id;
}
